import EditSettings from "./EditSettings.jsx";
export default EditSettings;